export default "__VITE_ASSET__BnrwQZF5__"